// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetBusinessDetailRequestModel from '../../model/get-business-detail-request-model';
import GetBusinessDetailRequestDTO from '../dto/get-business-detail-request-dto';
import dtoSchema from '../schemas/get-business-detail-request-schema';

export default abstract class GetBusinessDetailRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetBusinessDetailRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.contactId = data.contactId;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {uuid}
  */
  contactId?: string;

  static toModel(dto: DeepPartial<GetBusinessDetailRequestDTO>): GetBusinessDetailRequestModel;
  static toModel(dto: DeepPartial<GetBusinessDetailRequestDTO> | undefined | null): GetBusinessDetailRequestModel | undefined;
  static toModel(dto: DeepPartial<GetBusinessDetailRequestDTO> | undefined | null): GetBusinessDetailRequestModel | undefined {
    return dto ? new GetBusinessDetailRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetBusinessDetailRequestModel> | GetBusinessDetailRequestModel): GetBusinessDetailRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      contactId: unwrapped.contactId,
    } as GetBusinessDetailRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetBusinessDetailRequestModel, can not map to GetBusinessDetailRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
